















































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import { Exame } from '../../../../back/src/entity/Exame';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';

import Carregando from '../Carregando.vue';
import ResultadosDeExamesCollapse from '../resultados_de_exames/ResultadosDeExamesCollapse.vue';
import { GrupoExame } from '../../../../back/src/entity/GrupoExame';

export default Vue.extend({
  name: 'ThePacientesDadosExames',
  components: {
    Carregando,
    ResultadosDeExamesCollapse,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      loading: {
        resultados: true,
        resultadosRemovidos: true,
        exames: true,
        gruposExames: true,
      },
      gruposExames: [] as GrupoExame[],
      exames: [] as Exame[],
      resultadosDeExames: [] as ResultadoDeExame[],
      resultadosDeExamesRemovidos: [] as ResultadoDeExame[],
    };
  },
  computed: {
    loadingAll(): boolean {
      return this.loading.resultados
        || this.loading.resultadosRemovidos
        || this.loading.exames
        || this.loading.gruposExames;
    },
    gestacoesAnteriores(): Gestacao[] {
      return _.sortBy(
        _.filter(
          this.paciente.gestacoes as Gestacao[],
          gestacao => (!!gestacao.ended),
        ),
        ['data_parto'],
      );
    },
  },
  mounted() {
    this.buscaResultadosDeExames();
    this.buscaResultadosDeExamesRemovidos();
    this.buscaExames();
    this.buscaGruposExames();
  },
  methods: {
    resultadosDeExamesGestacao(gestacao: Gestacao | null): ResultadoDeExame[] {
      return _.filter(
        this.resultadosDeExames as ResultadoDeExame[],
        resultado => (
          !!gestacao && _.has(gestacao, 'id')
            ? resultado.gestacao_id === gestacao.id
            : !resultado.gestacao_id
        ),
      );
    },
    resultadosDeExamesRemovidosGestacao(gestacao: Gestacao | null): ResultadoDeExame[] {
      return _.filter(
        this.resultadosDeExamesRemovidos as ResultadoDeExame[],
        resultado => (
          !!gestacao && _.has(gestacao, 'id')
            ? resultado.gestacao_id === gestacao.id
            : !resultado.gestacao_id
        ),
      );
    },
    novoResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.resultadosDeExames.push(resultadoDeExame);
    },
    atualizaResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      const index = _.findIndex(
        this.resultadosDeExames as ResultadoDeExame[],
        resultado => resultadoDeExame.id === resultado.id,
      );
      if (index >= 0) {
        this.$set(this.resultadosDeExames, index, resultadoDeExame);
      }
    },
    restauraResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      // remove dos removidos
      _.remove(
        this.resultadosDeExamesRemovidos as ResultadoDeExame[],
        resultado => (resultado.id === resultadoDeExame.id),
      );
      // insere nos ativos
      this.resultadosDeExames.push(resultadoDeExame);
    },
    removeResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      // remove dos ativos
      _.remove(
        this.resultadosDeExames as ResultadoDeExame[],
        resultado => (resultado.id === resultadoDeExame.id),
      );
      // insere nos removidos
      this.resultadosDeExamesRemovidos.push(resultadoDeExame);
    },
    async buscaResultadosDeExames() {
      this.loading.resultados = true;
      try {
        const response = await Requester.paciente.resultadosDeExame(this.paciente.id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.resultadosDeExames = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.resultados = false;
      }
    },
    async buscaResultadosDeExamesRemovidos() {
      this.loading.resultadosRemovidos = true;
      try {
        const response = await Requester.paciente.resultadosDeExameRemovidos(
          this.paciente.id,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.resultadosDeExamesRemovidos = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.resultadosRemovidos = false;
      }
    },
    async buscaExames() {
      this.loading.exames = true;
      try {
        const response = await Requester.exame.exames();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.exames = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.exames = false;
      }
    },
    async buscaGruposExames() {
      this.loading.gruposExames = true;
      try {
        const response = await Requester.grupoExame.gruposExames();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.gruposExames = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.gruposExames = false;
      }
    },
  },
});
